import React, { Fragment } from "react";
import ApproveButton from "./buttons/ApproveButton";
import RejectButton from "./buttons/RejectButton";
import ResetAttemptsButton from "./buttons/ResetAttemptsButton";

const BulkActionButtons = (props) => (
	<Fragment>
		<ApproveButton {...props} />
		<RejectButton {...props} />
		<ResetAttemptsButton {...props} />
		{/* <ResetAttemptsButton /> */}
	</Fragment>
);
export default BulkActionButtons;
